import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideStore } from '@ngrx/store';
import { AppComponent } from './app/app.component';
import { CDKCoreModule } from '@rogers/cdk/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { ApiTokenRequestInterceptor } from './app/interceptors/api-token-request-interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { getMetaReducers } from './app/state/meta-reducers';
import { of } from 'rxjs';
import { appConfig, setupAppConfig } from './init/getAppConfig';
import { getTranslationsJson } from './init/getTranslationsJson';
import { updateVaStyleHref } from './init/updateVaStyleHref';
import { getBrand } from './utils/getBrand';
import { provideAppFeatures } from './app/state/provide-app-features';
import { getStoreIdb, initializeIdbKeyval } from './utils/idbKeyval';
import { UcxApiEnvRequestInterceptor } from './app/interceptors/ucx-api-env-request-interceptor';
import { loadAnalyticsLibrary } from './init/includeAnalyticsLibrary';

(async () => {
  updateVaStyleHref();
  const translations = await getTranslationsJson();
  await setupAppConfig();
  if (appConfig.production) {
    enableProdMode();
  }
  initializeIdbKeyval();
  const storeValueInIdb = await getStoreIdb();
  loadAnalyticsLibrary();
  await bootstrapAngularApplication({ storeValueInIdb, translations });
})();

const bootstrapAngularApplication = async ({
  storeValueInIdb,
  translations,
}) => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        CDKCoreModule.forRoot({
          brand: getBrand().cdkBrand,
        }),
        HttpClientModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useValue: {
              getTranslation: (lang: string) => {
                return of(translations[lang]);
              },
            },
          },
        }),
        NoopAnimationsModule
      ),
      provideStore({}, { metaReducers: getMetaReducers({ storeValueInIdb }) }),
      provideAppFeatures(),
      provideStoreDevtools({ trace: true }),
      {
        provide: APP_BASE_HREF,
        useValue: document.baseURI,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: UcxApiEnvRequestInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiTokenRequestInterceptor,
        multi: true,
      },
    ],
    // eslint-disable-next-line no-console
  }).catch((err) => console.error(err));
};
